import React from 'react';
import { View } from 'react-native';

import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { QueryFilter } from '../search/QueryFilter';
import { LocationFilter } from '../search/LocationFilter';
import SearchInputModalTrigger from '../search/SearchPopover/SearchInputModalTrigger';

import {
  BodyText,
  Button,
  HeaderText,
  Stack,
} from '../../ui';
import { ArrowRightCircleIcon, BasicSearchIcon } from '../../ui/Icons';

import './HomeHero.module.scss';
import { HomeHeroProps } from './types';

export const DeprecatedHomeHero = ({
  showSearchPopoverTrigger,
  updateQuery,
  mobileLayout,
  goToJoinPage,
  displayQ,
  locationRef,
  location,
  updateLocation,
  handleSearchPopoverClose,
  handleShortSubmitClick,
  handleQueryBlur,
}: HomeHeroProps) => (
  <View
    className="client-app"
    styleName="home-hero-component"
  >
    <View />
    <Stack styleName="home-hero-wrapper">
      <Box paddingBottom={16}>
        <HeaderText
          level={1}
          textAlign="left"
        >
          Discover &amp; book local beauty professionals
        </HeaderText>
      </Box>
      <View>
        {showSearchPopoverTrigger ? (
          <SearchInputModalTrigger source="home_hero" />
        ) : (
          <Inline alignItems="center" space={8}>
            <QueryFilter
              setQuery={updateQuery}
              onClosePopover={handleSearchPopoverClose}
              query={displayQ || ''}
              showSearchButton={false}
              onBlur={handleQueryBlur}
            />
            <LocationFilter
              ref={locationRef}
              address={location.address || ''}
              updateLocation={updateLocation}
            />
            <Button
              size="large"
              appearance="primary"
              onClick={handleShortSubmitClick}
              testID="search"
              style={{
                display: 'flex',
                padding: 8,
                borderRadius: 4,
              }}
            >
              <BasicSearchIcon color={BrandColor.WhiteWash} />
            </Button>
          </Inline>
        )}
      </View>
    </Stack>
    {(!mobileLayout) && (
      <Button
        onClick={goToJoinPage}
        appearance="silent"
        testID="joinAsProButton"
      >
        <Inline alignItems="center" space={4}>
          <ArrowRightCircleIcon color={BrandColor.FloraDark} />
          <BodyText color={BrandColor.FloraDark} weight="bold">
            Are you a barber or beauty professional?
          </BodyText>
        </Inline>
      </Button>
    )}
  </View>
);
